import React, { useCallback, useEffect } from 'react';
import * as Sentry from '@sentry/react';

import Button from 'components/form/Button.component';
import TextInput from 'components/form/TextInput.component';
import SENTRY from 'config/sentry.singleton';
import useStateWhileMounted from 'hooks/useStateWhileMounted.hook';
import useTip from 'hooks/useTip.hook';
import { nowAsIso } from 'utils/date/now.util';
import logger from 'utils/logger.util';

const CTAG = 'SentryPage';
const L = logger(CTAG);

const SentryPage = () => {
  const [text, setText] = useStateWhileMounted('');
  const { val: isEnabled, tip: toggle } = useTip(false);
  const handleText = useCallback((ev) => void setText(ev?.string), [setText]);

  const handleBlowUp = useCallback(() => {
    const now = nowAsIso();
    const message = `Testing Error for Sentry at ${now}`;
    L.debug('handleBlowUp()', now, { message, now });
    throw new Error(message);
  }, []);

  const handleSomeError = useCallback((ev) => {
    //
    const now = nowAsIso();
    const logger = CTAG;
    const tags = { handler: 'handleSomeError' };
    const extra = { ev: String(ev), now };
    const message = 'Testing some error';
    //
    L.debug('handleSomeError()', now, { ev, logger, tags, extra, message });
    SENTRY.warn({ logger, tags, extra, message });
    //
  }, []);

  useEffect(() => {
    // Sentry.addIntegration();
    if (isEnabled) {
      L.debug('useEffect()', 1, Sentry);
      L.debug('useEffect()', 2, Sentry.getCurrentScope());
      L.debug('useEffect()', 3, Sentry.Integrations);

      // Sentry.captureUserFeedback({
      //   event_id: 'string',
      //   email: `User['email']`,
      //   name: 'string',
      //   comments: 'string',
      // });
    }
  }, [isEnabled]);

  return (
    <div data-bem="SentryPage" style={{ background: 'gray', width: '100vw', height: '100vh' }}>
      <div style={{ display: 'flex' }}>
        <TextInput onChange={handleText} value={text} />
        <Button onClick={handleSomeError}>Use the text</Button>
        <Button tag="SentryPage__button" onClick={handleBlowUp}>
          BLOW UP
        </Button>
        <Button onClick={toggle}>{isEnabled ? 'Enabled' : 'Disabled'}</Button>
      </div>
    </div>
  );
};

export default SentryPage;
